import React from 'react';
import Grid from '@mui/material/Grid';
// import Avatar from '@mui/material/Avatar';
import { Link, Typography } from '@mui/material';



const CCA2023 = () => {
  return (
    
    <Typography align='center' variant='h4' fontWeight={800}>
    Co-Curricular Activities 2023-24</Typography>
  );
};

export default CCA2023;
